import React from 'react';
import { Box, Group, Text } from '@mantine/core';
import { IconClock } from '@tabler/icons-react';
import { PlaceTypeBadge } from './PlaceTypeBadge';
import type { RecentSearchItemProps } from '../types';
import styles from '../AddressSearchBar.module.css';

export const RecentSearchItem = React.memo<RecentSearchItemProps>(({
  recentSearch,
  index,
  isSelected,
  onSelect,
}) => {
  const handleClick = () => {
    onSelect(recentSearch);
  };

  return (
    <Box
      id={`address-option-${index}`}
      className={`${styles.resultItem} ${isSelected ? styles.selected : ''}`}
      onClick={handleClick}
      role="option"
      aria-selected={isSelected}
    >
      <Group gap="sm" wrap="nowrap" justify="space-between" className={styles.placeNameGroup}>
        <Group gap="sm" wrap="nowrap" className={styles.flexContainer}>
          <IconClock size={16} className={styles.clockIcon} />
          <Box className={styles.textContainer}>
            <Text size="sm" fw={500} lineClamp={1} className={styles.textTruncate}>
              {recentSearch.display_name.split(',')[0]}
            </Text>
            <Text size="xs" c="dimmed" lineClamp={1}>
              {recentSearch.display_name}
            </Text>
          </Box>
        </Group>
        {recentSearch.type && <PlaceTypeBadge type={recentSearch.type} />}
      </Group>
    </Box>
  );
});